<template>
  <Form :model="formItem" :label-width="80">
    <Row>
      <Col span="5">
      <FormItem label="国家/地区">
        <!--  <Countries @onSelect="on_select" @onSearch="on_search" @onBlur="on_blur"></Countries> -->
        <CountrySelect class="common-width" ref="countrySelector" @onClearText="onCountryClearText" @tag-Select="getCountrySelection"></CountrySelect>
      </FormItem>
      </Col>
      <Col span="5" :style="{paddingLeft:formItem.msgPadLeft}">
      <!--    <ValidMessage :msg="currentMsg"></ValidMessage> -->
      </Col>
    </Row>
    <!-- 注释于2019.08.19,注释原因：所有引擎取消时间查询条件,改为在二次检索结果中输入时间 -->
    <!-- <FormItem label="签订时间">
      <Row>
        <Col span="10">
        <DatePicker type="daterange" format="yyyy.MM.dd" placement="bottom-end" style="width: 250px" placeholder="签订时间" v-model="formItem.da" @on-change="timeOnChange"></DatePicker>
        </Col>
      </Row>
    </FormItem> -->

    <!-- <FormItem label="关键字">
      <Row>
        <Col span="10">
        <Input v-model="formItem.keywordValue" placeholder="请输入关键字" style="width: 250px" />
        </Col>
      </Row>
    </FormItem> -->
    <FormItem label="文件效力">
      <CountrySelect class="common-width" :tData="sTreeData" @onClearText="onForceClearText" @tag-Select="getForceSelection"></CountrySelect>
    </FormItem>

    <FormItem>
      <Button type="primary" icon="ios-search" size="default" @click="Submit()">查询</Button>
    </FormItem>
  </Form>
</template>
<script>
import Country from './country.vue'
import ValidMsg from './../valid_message.vue'
import TreeSingleselect from '../../common/tree-single-select.vue'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import SelectData from '../../../assets/json/selectData.json'
import treeData2 from '../../../assets/json/select-tree2.json'

var vMsg = {
  countryValid: {
    success: ["success", "匹配成功"],
    falure: ["error", "未匹配到相关国家或地区"],
    warning: ["warning", "匹配中"],
  }
}
export default {
  name: 'treatyform',
  data() {
    return {
      formItem: {
        country:{},
        keywordValue: "",
        da:[],
        msgPadLeft: "0px",
        fileforce: SelectData.fileforce
      },
      currentMsg: vMsg.countryValid.warning,
      countries: {},
      sTreeData: this.getSelectTreeData(),

    }
  },
  components: {
    // 'Countries': Country,
    'ValidMessage': ValidMsg,
    'CountrySelect': TreeSingleselect,
  },
  computed: {
    ...mapGetters(['sliderLength', 'sliderScreen', 'sta', 'countryData', 'isLogin'])
  },
  methods: {
    // on_select() {
    //   this.currentMsg = vMsg.countryValid.success;
    //   //console.log(this.currentMsg);
    // },
    // on_search(result) {
    //   if (result) {
    //     this.currentMsg = vMsg.countryValid.success;
    //   } else {
    //     this.currentMsg = vMsg.countryValid.falure;
    //   }
    // },
    // on_blur(result) {
    //   if (result) {
    //     this.currentMsg = vMsg.countryValid.success;
    //   } else {
    //     this.currentMsg = vMsg.countryValid.falure;
    //   }
    // },
    setSmallPadLeft() {
      this.formItem.msgPadLeft = "200px";
    },
    Submit() {

      if (this.sliderLength >= 2) {
        // this.screenSet(true);
      }
      this.$emit('onTreatySearch', this.formItem)
      //console.log(this.formItem)
      //this.expand();

    },
    getFormattedDate(date) {
      var year = date.getFullYear();
      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;
      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      return year + '-' + month + '-' + day;
    },
    timeOnChange() {
      var time = []
      if (this.formItem.da[0] !== "") {
        time[0] = this.getFormattedDate(this.formItem.da[0])
        time[1] = this.getFormattedDate(this.formItem.da[1])
        this.formItem.da=time
      }else{

      }
    },
    propDataInit(data, placeholder, searchable) {
      var a = {}
      a.data = data
      a.placeholder = placeholder
      a.searchable = searchable
      return a
    },
    getCountrySelection(node){
       this.formItem.country = node
    },
    onCountryClearText(){
      this.formItem.country={}
    },
    bindCountry() {
      let obj = this.propDataInit(this.sta.initData.country, "选择国家", true)
      this.countries = obj
      this.$refs.countrySelector.bindData(obj)
    },

    getSelectTreeData() {
      return treeData2.force
    },
    onForceClearText(){
      this.formItem.fileforce={}
    },
     getForceSelection(node){
      this.formItem.fileforce = node
    },
  },
  mounted(){
    this.bindCountry()
  },
  watch: {
    countryData: function() {
      // let obj=this.propDataInit(this.sta.initData.country,"选择国家",true)
      // this.$refs.countrySelector.bindData(obj)
      this.bindCountry()
    }
  },
}

</script>
<style scoped>
.common-width {
  width: 300px;
}

</style>
